import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-black mb-3" }, "Perfil académico", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-specialty"
}, "Especialidad", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-background"
}, "Experiencia laboral (resumen)", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h6", { class: "fw-semibold text-black mb-2 mt-2" }, "Pregrado", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-undergrad-name"
}, "Nombre del programa", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-undergrad-uni"
}, "Universidad", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-undergrad-date"
}, "Fecha de grado", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h6", { class: "fw-semibold text-black mb-2 mt-2" }, "Posgrado", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-postgrad-name"
}, "Nombre del programa", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-postgrad-uni"
}, "Universidad", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-postgrad-date"
}, "Fecha de grado", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h6", { class: "fw-semibold text-black mb-2 mt-2" }, "Información adicional", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-teacher-code"
}, "Código docente", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-years-exp"
}, "Años de experiencia", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-status"
}, "Estado actual", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h6", { class: "fw-semibold text-black mb-2 mt-2" }, "Importar hoja de vida", -1)
const _hoisted_17 = { class: "mb-15 mb-md-20 mb-lg-25" }
const _hoisted_18 = ["filechanged"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(_component_b_form_input, {
                  id: "input-specialty",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Specialty,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = val => _ctx.updateField('Specialty', val)),
                  placeholder: "Ej: Matemáticas, Lengua, Robótica",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_3,
                _createVNode(_component_b_form_input, {
                  id: "input-background",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.WorkBackground,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = val => _ctx.updateField('WorkBackground', val)),
                  placeholder: "Breve descripción de su experiencia",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_4,
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_5,
                _createVNode(_component_b_form_input, {
                  id: "input-undergrad-name",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.NameUndergraduate,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = val => _ctx.updateField('NameUndergraduate', val)),
                  placeholder: "Ej: Licenciatura en Educación",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_6,
                _createVNode(_component_b_form_input, {
                  id: "input-undergrad-uni",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.UniversityUndergrade,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = val => _ctx.updateField('UniversityUndergrade', val)),
                  placeholder: "Nombre de la universidad",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, { md: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_7,
                _createVNode(_component_b_form_input, {
                  id: "input-undergrad-date",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.DateUndergrade,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = val => _ctx.updateField('DateUndergrade', val)),
                  type: "date"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_8,
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_9,
                _createVNode(_component_b_form_input, {
                  id: "input-postgrad-name",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.NamePostgraduate,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = val => _ctx.updateField('NamePostgraduate', val)),
                  placeholder: "Ej: Maestría en Educación",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_10,
                _createVNode(_component_b_form_input, {
                  id: "input-postgrad-uni",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.UniversityPostgraduate,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = val => _ctx.updateField('UniversityPostgraduate', val)),
                  placeholder: "Nombre de la universidad",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, { md: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_11,
                _createVNode(_component_b_form_input, {
                  id: "input-postgrad-date",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.DatePostgraduate,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = val => _ctx.updateField('DatePostgraduate', val)),
                  type: "date"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_12,
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, { md: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_13,
                _createVNode(_component_b_form_input, {
                  id: "input-teacher-code",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.TeacherCode,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = val => _ctx.updateField('TeacherCode', val)),
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, { md: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_14,
                _createVNode(_component_b_form_input, {
                  id: "input-years-exp",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.YearsOfExperience,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = val => _ctx.updateField('YearsOfExperience', _ctx.toNumber(val))),
                  type: "number",
                  min: "0"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, { md: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_15,
                _createVNode(_component_b_form_input, {
                  id: "input-status",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.CurrentStatus,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = val => _ctx.updateField('CurrentStatus', val)),
                  placeholder: "Ej: Activo, Licencia, Retirado",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, { md: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_checkbox, {
                  modelValue: _ctx.recordProxy.HasTeachingLicense,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = val => _ctx.updateField('HasTeachingLicense', !!val))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Posee licencia docente ")
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, { md: "12" }, {
          default: _withCtx(() => [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("input", {
                class: "form-control fs-15 text-black shadow-none",
                id: "formFile",
                type: "file",
                filechanged: _ctx.handleFileChange,
                accept: "application/pdf"
              }, null, 8, _hoisted_18)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}